import styled from "styled-components";

export const GeneralContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.neutral.white};
  .header-label {
    font-size: 15px;
    font-weight: 700;
  }
  .header-icon {
    display: grid;
    grid-template-columns: 90% 10%;
    width: 100%;
    align-items: center;
    padding: 10px 10px 0px 10px;
  }
`;
export const ContentContainer = styled.div`
  margin-left: 5%;
  width: 90%;
`;
export const AddIcon = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;
